import { AuthContextState } from '../context/AuthContext';
import Button from '../../generic/Button';
import { hardRedirectTo } from '../../../utils';

type SamlLoginButtonProps = Pick<AuthContextState, 'samlURL'>;

const SamlLoginButton = ({ samlURL }: SamlLoginButtonProps) => (
  <div className="margin-bottom-sm">
    <Button
      type="secondary"
      size="large"
      onClick={() => samlURL && hardRedirectTo(samlURL)}
      isFullWidth
    >
      Sign In with SAML
    </Button>
  </div>
);

export default SamlLoginButton;
